import { ReactComponent as AddPlusIcon } from "../../../../assets/icons/add-plus-icon.svg";
import StockDropDownInput from "../../../common/VariantComponents/StockDropDownInput";
import VariantDropdown from "../../../common/VariantComponents/VariantDropdown";
import CreatedVariant from "../../../common/VariantComponents/CreatedVariant";
import React, { useState, useEffect, useMemo, useRef, Fragment } from "react";
import ImageAddModal from "../../../common/Modals/ImageAddModal";
import { ImageModal } from "../../../common/Modals";
import { Grid, Box } from "@mui/material";
import UBButton from "../../../../Libraries/UBButton";
import UBInput from "../../../../Libraries/UBInput";
import { handleApi } from "../../../../apis";
import {
  TitleAndActionBox,
} from "../../../common";
import { toast } from "react-toastify";
import {
  getBase64FromFile,
  handleUploadImage,
  roundToTwoDp,
  camelCase,
} from "../../../../constants";
import {
  PUT_UPDATE_DELETE_SELLER_PRODUCT,
  V2_POST_CREATE_SELLER_PRODUCT,
  GET_VARIANT_ATTRIBUTES,
  DELETE_SELLER_PRODUCT,
} from "../../../../apis/configuration";
import {
  AppImageUploader,
  AppInputDropDown,
  AppCheckbox,
  AppSwitch,
  ParagraphText,
} from "../../../../Libraries";
import {
  checkDeletedAttributeOptions,
  mapAttributeObjectToList,
  transformVariantImages,
  CREATED_VARIANT_FIELDS,
  generateVariantsData,
  mapLabelToAttributes,
  getAllAttributeIds,
  handleIntegerInput,
  showUpdatedVariant,
  checkDraginLimit,
  validateVariants,
  handleNumerInput,
  variantTableHead,
  combineVariants,
  VariantGeneral,
  ATTR_ACTIONS,
} from "../../../../constants/variantConstants";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { EnterIcon } from "../../../../assets/icons/icon";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import { ValidateUploadedFile } from "../../../../utils";
import { useSnackbar } from "../../../../context/SnackbarContext";


let periods = [
  "counter claim",
  "no claim",
  "1 month",
  "2 months",
  "3 months",
  "4 months",
  "5 months",
  "6 months",
  "7 months",
  "8 months",
  "9 months",
  "10 months",
  "11 months",
  "12 months",
];

const CreateStock = ({ data }) => {
  const { handleClose, handleStock, categories, stock, I18n, isReadOnly } = data || {};

  let initialMount = useRef(true);

  const [load, setload] = useState({ publishLoad: false, createLoad: false });
  const [publishModal, setPublishModal] = useState(false);
  const [subCategories, setSubCategories] = useState({});
  const [imageModal, setImageModal] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [errors, setErrors] = useState({});
  const [brands, setBrands] = useState({});
  const [isVariantAdded, setIsVariantAdded] = useState(
    stock?.variants?.length ? true : false
  );
  const [selectedAttributes, setSelectedAttributes] = useState(
    stock?.variants?.length
      ? mapAttributeObjectToList(stock?.attributes)
      : [{ keyId: "", attrOptions: [] }]
  );
  const [isEditMode, setIsEditMode] = useState([false, false, false]);
  const [attrAction, setAttrAction] = useState({
    action: null,
    index: null,
  });
  const [createdVariants, setCreatedVariants] = useState(
    stock?.variants?.length
      ? transformVariantImages(mapLabelToAttributes(stock?.variants))
      : []
  );

  const [showImageModal, setShowImageModal] = useState({
    show: false,
    value: null,
  });
  const [showVariantErr, setShowVariantErr] = useState(false);
  const [attrBtnClick, setAttrBtnClick] = useState(false);
  const [imageList, setImageList] = useState(
    Array.from({ length: 1 }, () => null)
  );
  const [deletedImgObj, setDeletedImgObj] = useState({});
  const [deletedVariantList, setDeletedVariantList] = useState([]);
  const [deletedAttributeList, setDeletedAttributeList] = useState([]);
  const [stockDetails, setStockDetails] = useState({
    min_order_qty: stock?.minimum_order_quantity || "",
    terms_and_cond: stock?.term_and_conditions || "",
    warranty_period: stock?.warranty_period || "",
    wholesale_price: stock?.wholesale_price || "",
    out_of_stock: stock?.out_of_stock || false,
    specification: stock?.specifications || "",
    sub_category: stock?.sub_category || "",
    quantity: stock?.stock_quantity || "",
    product_image: stock?.image_url || "",
    image_url: stock?.image_url || "",
    name: stock?.product_name || "",
    discount: stock?.discount || "",
    category: stock?.category || "",
    weight: stock?.weight || "",
    brand: stock?.brand || "",
    msrp: stock?.msrp || "",
  });
  const [isVariantLoading, setIsVariantLoading] = useState(false);
  const [varianData, setVariantData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);

  const dragOverRef = useRef(null);
  const dragStartRef = useRef([]);
  const isVarMount = useRef(true);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const handleUpdateImageList = () => {
      let cloneImgs = Array.from(
        { length: createdVariants.length || 1 },
        () => null
      );
      cloneImgs = cloneImgs.map((val, ind) => imageList[ind] || null);
      setImageList(cloneImgs);
    };
    handleUpdateImageList();
  }, [createdVariants, isVariantAdded]);

  useEffect(() => {
    if (stock && stock?.variants?.length) {
      setImageList(
        stock.variants?.map((val) =>
          val?.images?.[0]
            ? {
              ...val?.images?.[0],
            }
            : null
        )
      );
    }
  }, [stock]);

  useEffect(() => {
    if (stock && stock?.variants?.length && isVarMount.current) {
      isVarMount.current = false;
      setCreatedVariants((curr) => {
        return showUpdatedVariant(selectedAttributes, curr);
      });
      return;
    }
    if (attrBtnClick) return;
    else {
      setCreatedVariants((curr) => {
        return combineVariants(selectedAttributes, curr, attrAction);
      });
      if (stock && stock?.variants?.length && handleVariantValidation()) {
        setDisabled(!isVarMount.current ? false : handleDisabled());
      } else {
        if (!stock) setDisabled(false);
      }
    }
  }, [selectedAttributes]);

  useEffect(() => {
    if (stock) createHashMap();
  }, [stock]);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
      return;
    } else setDisabled(false);
  }, [stockDetails]);

  //calling for get variants API on mount componenet
  useEffect(() => {
    setIsVariantLoading(true);
    handleApi(GET_VARIANT_ATTRIBUTES, {}, null, navigate)
      .then((res) => {
        const variants = generateVariantsData(res.data);
        setVariantData(variants);
        setIsVariantLoading(false);
      })
      .catch((err) => {
        setIsVariantLoading(false);
        toast.error(err?.response?.data?.message || "Something went wrong", {
          className: "errorToast",
        });
      });
  }, []);

  const handleVariantValidation = () =>
    validateVariants(createdVariants).length ||
    validateVariants(createdVariants).length === createdVariants.length;

  const handleSetEdit = (index, value) => {
    let editClone = [...isEditMode];
    editClone = editClone.map((ed, ind) => (ind === index ? value : false));
    setIsEditMode(editClone);
  };
  const handleDragAttr = (e) => {
    const isInLimit = checkDraginLimit(
      e?.clientX,
      e?.clientY,
      "all-selected-attrs"
    );
    if (isInLimit) {
      if (
        dragOverRef.current == null ||
        dragStartRef.current == null ||
        dragOverRef.current === dragStartRef.current
      ) {
        dragOverRef.current = null;
        dragStartRef.current = null;
        return;
      } else {
        setAttrAction({ action: ATTR_ACTIONS.ATTR_DRAG, index: null });
        let tempClone = JSON.parse(JSON.stringify(selectedAttributes));
        [tempClone[dragOverRef.current], tempClone[dragStartRef.current]] = [
          tempClone[dragStartRef.current],
          tempClone[dragOverRef.current],
        ];
        setSelectedAttributes(tempClone);
        dragOverRef.current = null;
        dragStartRef.current = null;
      }
    }
  };
  const handleDeleteVariant = (variantInd) => {
    if (createdVariants.length > 1) {
      const clonedVars = [...createdVariants];
      clonedVars.splice(variantInd, 1);
      setCreatedVariants(clonedVars);
    }
    if (stock && stock?.variants?.length) {
      const deletedVar = createdVariants[variantInd];
      if (deletedVar?.id) {
        const currentDeleteList = [...deletedVariantList];
        currentDeleteList.push(deletedVar?.id);
        setDeletedVariantList(currentDeleteList);
      }
    }
    setDisabled(false);
  };
  const handleImgModClose = () => setShowImageModal(false);
  const handleDeleteImgObj = (vID, value) => {
    const currentDeleteObj = { ...deletedImgObj };
    currentDeleteObj[vID] = [
      ...(currentDeleteObj[vID] || []),
      { image_id: value, flag: "deleted" },
    ];
    setDeletedImgObj(currentDeleteObj);
  };
  const handleImgModSave = (imageInd, action = "ADD") => {
    if (action === "DELETE") {
      const variantClone = createdVariants.map((variant) => {
        const variantId = variant?.id;
        const variantImg = variant?.images?.[0];
        if (variantImg?.imageLibIndex === imageInd) {
          if (Boolean(stock) && variantId && variantImg?.id) {
            handleDeleteImgObj(variantId, variantImg?.id);
          }
          return {
            ...variant,
            [CREATED_VARIANT_FIELDS.IMAGES]: null,
          };
        } else {
          return variant;
        }
      });
      setCreatedVariants(variantClone);
    } else {
      if (imageInd !== null && showImageModal.value !== null) {
        const selectedVariant = createdVariants[showImageModal.value];
        const currentImageID = selectedVariant?.images?.[0]?.id;
        if (Boolean(stock) && selectedVariant?.id && currentImageID) {
          handleDeleteImgObj(selectedVariant?.id, currentImageID);
        }
        handleUpdateVariantField(
          showImageModal.value,
          imageList?.[imageInd]?.image_url
            ? [
              {
                image: imageList?.[imageInd]?.image_url,
                imageLibIndex: imageInd,
              },
            ]
            : null,
          CREATED_VARIANT_FIELDS.IMAGES
        );
        setShowImageModal({ show: false, value: null });
        return;
      } else {
        toast.error("Please select an Image first", {
          className: "errorToast",
        });
      }
    }
  };

  const handleImgModCancel = handleImgModClose;

  const handleUpdateVariantField = (ind, val, updateField) => {
    setShowVariantErr(false);
    const cloneVars = [...createdVariants];
    cloneVars[ind][updateField] = val;
    setCreatedVariants(cloneVars);

    if (stock && handleVariantValidation()) {
      setDisabled(!isVarMount.current ? false : handleDisabled());
    } else {
      if (!stock) setDisabled(false);
    }
  };

  const handleCallUpdateVariant = (ind, updateObj) => {
    const cloneVars = [...createdVariants];
    cloneVars[ind] = { ...cloneVars[ind], ...updateObj };
    setCreatedVariants(cloneVars);
  };

  const handleSaveAttributeOptions = (
    keyId,
    options,
    prevId = "",
    changeInd
  ) => {
    return handleSelectAttribues(changeInd, prevId, keyId, options);
  };

  const handleSelectAttribues = (changeInd, prevKey, key, changeVal) => {
    const current = [...selectedAttributes];
    setAttrBtnClick(false);

    if (stock && stock.variants?.length) {
      let deletedAttributes = checkDeletedAttributeOptions(
        current[changeInd].attrOptions,
        changeVal
      );

      const deletedAttrNames = deletedAttributes.map(
        (attr) => attr?.value || ""
      );

      const finalDeletedAttrs = deletedAttributes
        .filter((attr) => attr?.id)
        .map((attr) => attr?.id);

      const recursiveDeletedVariants = createdVariants
        .filter((crv) => {
          const attribute = crv.attributes[current[changeInd]?.keyId];
          if (
            deletedAttrNames.includes(attribute.value) &&
            (crv?.id || crv?.variant_id)
          ) {
            return true;
          } else {
            return false;
          }
        })
        .map((variant) => variant?.id || variant?.variant_id);

      setDeletedVariantList((current) => [
        ...current,
        ...recursiveDeletedVariants,
      ]);
      const currentList = [...deletedAttributeList, ...finalDeletedAttrs];
      setDeletedAttributeList(currentList);
    }

    if (key === "" && changeVal.length === 0) {
      current.splice(changeInd, 1);

      if (selectedAttributes.length === 1) {
        setAttrAction({ action: null, index: null });
        current.push({ keyId: "", attrOptions: [] });
        setIsVariantAdded(false);
      } else {
        setAttrAction({ action: ATTR_ACTIONS.ATTR_DELETED, index: changeInd });
      }

      setSelectedAttributes([...current]);
      return;
    }

    let ind = current.findIndex((val) => val.keyId === key);

    if (ind === -1 || changeInd === ind) {
      current[changeInd] = {
        keyId: key,
        attrOptions: changeVal,
      };
      setSelectedAttributes([...current]);
      if (ind === -1) {
        setAttrAction({ action: ATTR_ACTIONS.ATTR_ADDED, index: changeInd });
        triggerLogEvent(analytics, "sc_stock_create_variants", {
          variant_count: selectedAttributes.length,
        });
      } else {
        setAttrAction({
          action: ATTR_ACTIONS.ATTR_OPTIONS_UPDATED,
          index: changeInd,
        });
      }
      return;
    } else {
      return "error";
    }
  };

  /**
   * Getting list of sub_categories by value or by category.
   * @returns sub_categories
   */
  const createHashMap = (value) => {
    let sub_categories = {};
    let allBrands = {};

    categories[value || stock.category]?.sub_categories.map(
      (val) => (sub_categories[val.name] = val)
    );
    categories[value || stock.category]?.brands.map(
      (val) => (allBrands[val.name] = val)
    );

    setBrands(allBrands);
    setSubCategories(sub_categories);
  };

  /**
   * Handle condition to disable or enable button. Delete those field because of optional
   * @returns true or false
   */
  const handleDisabled = () => {
    let arr = { ...stockDetails };
    delete arr["terms_and_cond"];
    delete arr["min_order_qty"];
    delete arr["out_of_stock"];
    delete arr["discount"];
    delete arr["msrp"];

    if (!isVariantAdded) {
      return Object.values(arr).some((val) => !val);
    } else {
      delete arr["wholesale_price"];
      delete arr["quantity"];
      delete arr["weight"];
      return (
        Object.values(arr).some((val) => !val) ||
        !validateVariants(createdVariants).length ||
        !(validateVariants(createdVariants).length === createdVariants.length)
      );
    }
  };

  /**
   * Handling validations of required fileds
   * @returns error object or epmty object
   */
  const Validation = () => {
    let obj = {};

    const {
      wholesale_price,
      warranty_period,
      product_image,
      specification,
      sub_category,
      category,
      quantity,
      discount,
      weight,
      brand,
      name,
    } = stockDetails || {};
    if (!isVariantAdded) {
      if (!name) obj.name = "Name is required";
      else if (!category) obj.category = "Category is required";
      else if (!sub_category) obj.sub_category = "Sub category is required";
      else if (!brand) obj.brand = "Brand is required";
      else if (!product_image) obj.product_image = "Image is required";
      else if (!wholesale_price) obj.wholesale_price = "Price is required";
      else if (!quantity || quantity <= 0)
        obj.quantity = "Quantity is required";
      else if (!weight || weight <= 0) obj.weight = "Weight is required";
      else if (!specification) obj.specification = "Specification is required";
      else if (!warranty_period)
        obj.warranty_period = "Warranty period is required";
      else if (
        Number(discount || 0) &&
        Number(discount || 0) >= Number(wholesale_price)
      )
        obj.discount_optional = I18n.discount_more_than_price;
    } else {
      if (!name) obj.name = "Name is required";
      else if (!category) obj.category = "Category is required";
      else if (!sub_category) obj.sub_category = "Sub category is required";
      else if (!brand) obj.brand = "Brand is required";
      else if (!product_image) obj.product_image = "Image is required";
      else if (!specification) obj.specification = "Specification is required";
      else if (!warranty_period)
        obj.warranty_period = "Warranty period is required";
      else if (
        !validateVariants(createdVariants).length ||
        !(validateVariants(createdVariants).length === createdVariants.length)
      ) {
        if (!selectedAttributes?.[0]?.keyId) {
          toast.error("Please save attributes to create variants.", {
            className: "errorToast",
            toastId: "add_attribute_toast",
            autoClose: 3500,
          });

          document
            .getElementById("attributes-ui")
            ?.scrollIntoView?.({ behavior: "smooth" });
        } else {
          toast.error("Please add all the variants data", {
            className: "errorToast",
            toastId: "add_variant_toast",
            autoClose: 3500,
          });
          document
            .getElementById("variants-ui")
            ?.scrollIntoView?.({ behavior: "smooth" });
          setShowVariantErr(true);
        }
        return {
          variant: "required",
        };
      }
    }
    try {
      if (Object.keys(obj).length) {
        document
          .getElementById(Object.keys(obj)[0])
          .scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
    }

    return obj;
  };

  /**
   * Calling api for create or updtae stock. Publish param for publish stock or not
   * @returns success or error of create or updtae stock
   */
  const handleCreatStock = async (publish) => {
    if (Object.values(Validation()).length) setErrors(Validation());
    else {
      setErrors({});
      if (publish && !publishModal) togglePublishModal(true);
      else {
        const {
          wholesale_price,
          warranty_period,
          terms_and_cond,
          product_image,
          min_order_qty,
          specification,
          sub_category,
          out_of_stock,
          quantity,
          discount,
          category,
          weight,
          brand,
          name,
          msrp,
        } = stockDetails || {};

        const JSON_CONV = {
          sub_category_id: Number(subCategories?.[sub_category]?.id),
          out_of_stock: Boolean(out_of_stock),
          publish: Boolean(publish),
          term_and_conditions: terms_and_cond,
          warranty_period: warranty_period,
          category_id: categories?.[category]?.id,
          specifications: specification,
          discount: Number(discount) || 0,
          brand_id: Number(brands?.[brand]?.id),
          product_name: name,
          unit: "Pcs",
          minimum_order_quantity: Number(min_order_qty) || 0,
          wholesale_price: Number(wholesale_price) || 0,
          stock_quantity: 50,
          weight: Number(weight) || 0,
          msrp: Number(msrp) || 0,
        };

        let productB64 = product_image;

        if (typeof product_image !== typeof "") {
          productB64 = await getBase64FromFile(product_image);
          productB64 = productB64.replace(/^.*,/, "");
        }

        if (stock) {
          JSON_CONV["product_id"] = stock.id;
          JSON_CONV["update"] = true;
        }

        const updatedVar = JSON.parse(JSON.stringify(createdVariants))?.map(
          (vari) => {
            for (let key in vari.attributes) {
              if (vari?.attributes?.hasOwnProperty?.(key)) {
                if (key.toLowerCase() === "Color".toLowerCase()) {
                  vari.attributes[key]["meta"] = {
                    hexcode: vari?.attributes?.[key]?.["label"],
                  };
                } else {
                  vari.attributes[key]["meta"] =
                    vari?.attributes?.[key]?.["label"];
                }
              }
            }

            if (vari?.images?.length && Array.isArray(vari?.images)) {
              vari.images = vari?.images?.map((val, ind) => {
                if (typeof val?.image === typeof "" && !val?.id) {
                  return {
                    image: val.image.replace(/^.*,/, ""),
                    ...(stock ? { flag: "created" } : {}),
                  };
                } else {
                  return val;
                }
              });
            } else {
              vari.images = [];
            }

            if (
              vari?.images?.length &&
              Boolean(stock) &&
              deletedImgObj?.[vari.id] &&
              vari?.id
            ) {
              vari.images = [
                ...vari?.images,
                ...(deletedImgObj?.[vari.id] || []),
              ];
            }

            return vari;
          }
        );

        JSON_CONV.variants = updatedVar;

        if (
          stock &&
          stock.variants?.length &&
          Object.keys(stock?.attributes)?.length &&
          !isVariantAdded
        ) {
          const deleted_vars = stock.variants
            .map((value) => value?.id)
            .filter((val) => val);
          const deleted_attrs = getAllAttributeIds(stock?.attributes);
          JSON_CONV.variants = [];
          JSON_CONV.deleted_variants = deleted_vars;
          JSON_CONV.deleted_attributes = deleted_attrs;
        }

        JSON_CONV.product_image = productB64;

        if (stock && deletedAttributeList?.length) {
          JSON_CONV.deleted_attributes = deletedAttributeList;
        }

        if (stock && deletedVariantList?.length) {
          JSON_CONV.deleted_variants = deletedVariantList;
        }

        setload({ createLoad: !publish, publishLoad: publish });
        handleStock(
          stock
            ? PUT_UPDATE_DELETE_SELLER_PRODUCT
            : V2_POST_CREATE_SELLER_PRODUCT,
          JSON_CONV,
          stock ? true : false
        )
          .then(() => {
            handleClose();
            if (publishModal) togglePublishModal();
            toast.success(
              `Stock ${stock ? "updated" : "created"} sucessfully`,
              { className: "successToast" }
            );
            if (!publish) {
              triggerLogEvent(analytics, "sc_stock_create_save", {
                stock_id: stock?.id || "new",
                is_variant_added: isVariantAdded,
              });
            } else {
              triggerLogEvent(analytics, "sc_stock_create_publish", {
                stock_id: stock?.id || "new",
              });
            }
          })

          .catch((err) => {
            if (publishModal) togglePublishModal();
            return toast.error(
              err?.response?.data?.message || "Something went wrong",
              { className: "errorToast" }
            );
          })
          .finally(() => setload({ createLoad: false, publishLoad: false }));
      }
    }
  };

  /**
   * Changing specific state by value with respect to key
   * @returns Update specific state
   */
  const onChangeText = (key, value, subVaue) => {
    setStockDetails((prev) => {
      let all = { ...prev };

      switch (key) {
        case I18n.out_of_stock:
          all.out_of_stock = value.target.checked;
          break;
        case I18n.minimum_order_qty_optional:
          all.min_order_qty = value;
          break;
        case I18n.warranty_period:
          all.warranty_period = value;
          triggerLogEvent(analytics, "sc_stock_create_policy", {
            warranty_period: value,
            terms_length: all.terms_and_cond?.length || 0,
          });
          if (errors.warranty_period) {
            setErrors({ ...errors, warranty_period: "" });
          }
          break;
        case I18n.wholesale_price:
          all.wholesale_price = value;
          if (errors.wholesale_price) {
            setErrors({ ...errors, wholesale_price: "" });
          }
          if (value && Number(value) > Number(all.discount || 0)) {
            triggerLogEvent(analytics, "sc_stock_create_discounts", {
              discount: value,
            });
            setErrors({
              ...errors,
              discount_optional: "",
            });
          } else if (value && Number(value) <= Number(all.discount || 0)) {
            setErrors({
              ...errors,
              discount_optional: I18n?.discount_more_than_price,
            });
          }
          break;
        case I18n.sub_category:
          all.sub_category = value;
          if (errors.sub_category) setErrors({ ...errors, sub_category: "" });
          break;
        case I18n.item_details:
          all.specification = value;
          if (errors.specification) setErrors({ ...errors, specification: "" });
          break;
        case I18n.brand:
          all.brand = value;
          if (errors.brand) setErrors({ ...errors, brand: "" });
          break;
        case I18n.category:
          all.category = value;
          all.sub_category = "";
          all.brand = "";
          createHashMap(value);
          if (errors.category) setErrors({ ...errors, category: "" });
          break;
        case I18n.discount_optional:
          all.discount = value;

          if (value && Number(value) >= Number(all.wholesale_price)) {
            setErrors({
              ...errors,
              discount_optional: I18n?.discount_more_than_price,
            });
          } else {
            setErrors({
              ...errors,
              discount_optional: "",
            });
          }
          break;
        case I18n.upload_photo:
          all.product_image = subVaue;
          all.image_url = value;
          if (errors.product_image) setErrors({ ...errors, product_image: "" });
          break;
        case I18n.quantity:
          all.quantity = value;
          if (errors.quantity) setErrors({ ...errors, quantity: "" });
          break;
        case I18n.name:
          all.name = value;
          if (errors.name) setErrors({ ...errors, name: "" });
          break;
        case I18n.msrp_optional:
          all.msrp = value;
          if (errors.msrp) setErrors({ ...errors, msrp: "" });
          break;
        case I18n.weight_gm:
          all.weight = value;
          if (errors.weight) setErrors({ ...errors, weight: "" });
          break;
        default:
          all.terms_and_cond = value;
          if (errors.terms_and_cond)
            setErrors({ ...errors, terms_and_cond: "" });
      }
      return all;
    });
  };

  /**
   * Handle image re-upload
   * @returns image
   */

  const handleReupload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const file = event.target.files[0];
      const valid = ValidateUploadedFile({ file, I18n });
      if (!valid.valid) {
        showSnackbar({ message: valid.message, severity: "error" });
        return false;
      }
      handleUploadImage(file, (result) =>
        onChangeText(I18n.upload_photo, result, file)
      );
    };
    input.click();
  };

  /**
   * Toggle image modal by toggle value
   * @returns true or false
   */
  const toggleImageModal = (toggle = false) => setImageModal(toggle);

  /**
   * Toggle publish modal by toggle value
   * @returns true or false
   */
  const togglePublishModal = (toggle = false) => setPublishModal(toggle);

  /**
   * Delete image and close image modal
   * @returns delete image
   */
  const handleDeleteImage = () => {
    setStockDetails({ ...stockDetails, product_image: "", image_url: "" });
    toggleImageModal();
  };

  const varaintKeys = Object.keys(varianData);

  const isAttributeButtonDisabled = useMemo(() => {
    return (
      selectedAttributes.every((x) => x?.attrOptions?.length) &&
      selectedAttributes.length < (varaintKeys.length || 3)
    );
  }, [selectedAttributes]);

  const handleCreateEditStock = () => {
    triggerLogEvent(analytics, "sc_stock_edit_btn", { product_id: stock?.id });
    navigate(`/SaddarInventory/EditStock/${stock.id}`);
  };

  const toggleDeleteModal = (toggle = false) => setDeleteModal(toggle);

  /**
    * Calling an api to delete stock
    * @returns success or error of delete stock
    */
  const handleDeleteStock = () => {
    if (!deleteModal) {
      triggerLogEvent(analytics, "sc_stock_delete_btn", { product_id: stock?.id });
      toggleDeleteModal(true);
    } else {
      setDeleteLoad(true);
      handleApi(DELETE_SELLER_PRODUCT, {
        product_id: stock.id,
        active: "False",
      }, null, navigate)
        .then(() => {
          toggleDeleteModal();
          navigate("/SaddarInventory", {
            replace: true,
          });
          toast.success("Stock deleted successfully", {
            className: "successToast",
          });
        })
        .finally(() => setDeleteLoad(false));
    }
  };

  return (
    <Grid
      container
      className={`${styles.root} ${styles.StockManagementFormWrapper} SaleExpenseForm`}
    >
      <Grid item md={12}>
        <TitleAndActionBox
          data={{
            id: isReadOnly ? "stock_detail" : stock ? "edit_stock" : "create_stock",
            title: isReadOnly ? <div className={styles.subHeaderLeft}>
              {camelCase(stockDetails.name)}{" "}
              <ParagraphText className={"statusBox"}>
                {I18n[stock.approval_status]
                  ? I18n[stock.approval_status].toUpperCase()
                  : ""}
              </ParagraphText>
            </div> : stock ? "edit_stock" : "create_stock",
            isBack: true,
            isTitleCase: false,
          }}
        >
          {
            isReadOnly && <Box display={"flex"} gap={2}>
              <UBButton
                id="stock_detail_edit_btn"
                title={I18n.edit}
                className={"ubPrimaryButton"}
                onClick={() => handleCreateEditStock(true)}
              />
              <UBButton
                id="stock_detail_delete_btn"
                title={I18n.delete}
                className={"ubSecondayButton"}
                onClick={() => handleDeleteStock(true)}
                disabled={deleteLoad}
              />
            </Box>
          }
        </TitleAndActionBox>

        <Box className={styles.formBodyGrid} onKeyDown={(e) => {
          if (e.key === "Enter" && (!disabled || !load.createLoad) && !isReadOnly) {
            handleCreatStock(true)
          }
        }}>
          <Box
            className={`${styles.formColumn}`}
          >
            <Box
              className={`${styles.formBody}`} >
              <ParagraphText>{I18n.item_details}</ParagraphText>
              <div className={styles.ItemNameInputBox}>
                <div className="createFormGridLeft DropdowcustomSelector">
                  <UBInput
                    inputId="create_stock_name_input"
                    readOnly={isReadOnly}
                    required
                    value={stockDetails.name}
                    label={"Item name"}
                    onChange={(key, value) => {
                      onChangeText(I18n.name, value);
                      const dc = document.getElementById("category");
                    }}
                    error={{ show: errors?.name, text: errors?.name }}
                    maxLength={128}
                    baseId={"name"}
                    placeholder={I18n.placeholder_item_name}
                  />

                  <AppInputDropDown
                    className={styles.inputDropDown}
                    data={{
                      list: Object.keys(categories) || [],
                      value: stockDetails.category,
                      error: errors?.category,
                      title: I18n.category,
                      id: "category",
                      onChangeText,
                      required: true,
                    }}
                    RenderInput={(params = {}) => (
                      <StockDropDownInput
                        params={params}
                        // label={I18n.category}
                        placeholder={I18n.placeholder_item_category}
                        disabled={isReadOnly}
                      />
                    )}
                  />
                </div>
                <div className={styles.createFormGridRight}>
                  <Box className={styles.ImageUploaderinner}>
                    <span className="imageuploaderAsterik">*</span>
                    <AppImageUploader
                      toggleImageModal={toggleImageModal}
                      image={stockDetails.image_url}
                      error={errors?.product_image}
                      handleImage={onChangeText}
                      title={I18n.upload_photo}
                      id="product_image"
                      I18n={I18n}
                      readOnly={isReadOnly}
                    />
                  </Box>
                </div>
              </div>

              <Grid container spacing={"10px"}>
                <Grid item md={6}>
                  <AppInputDropDown
                    className={styles.inputDropDown}
                    data={{
                      list: Object.keys(subCategories) || [],
                      value: stockDetails.sub_category,
                      error: errors?.sub_category,
                      title: I18n.sub_category,
                      id: "sub_category",
                      onChangeText,
                      required: true
                    }}
                    RenderInput={(params = {}) => (
                      <StockDropDownInput
                        params={params}
                        // label={I18n.sub_category}
                        placeholder={I18n.placeholder_item_subcat}
                        disabled={isReadOnly}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={6}>
                  <AppInputDropDown
                    className={styles.inputDropDown}
                    data={{
                      list: Object.keys(brands) || [],
                      value: stockDetails.brand,
                      error: errors?.brand,
                      title: I18n.brand,
                      onChangeText,
                      id: "brand",
                      required: true
                    }}
                    RenderInput={(params = {}) => (
                      <StockDropDownInput
                        params={params}
                        // label={I18n.brand}

                        placeholder={I18n.placeholder_item_brand}
                        className="w-100"
                        disabled={isReadOnly}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <ParagraphText className="fontSize16 fontWeight500 newFontColor">
                {camelCase(I18n.add_variants)}
              </ParagraphText>
              <AppCheckbox
                disabled={isReadOnly}
                label={I18n.this_product_has_options_like_size_or_color}
                onClick={(e) => { triggerLogEvent(analytics, "sc_stock_toggle_variants", { enabled: !isVariantAdded }); setIsVariantAdded((x) => !x); }}
                checked={isVariantAdded}
              />
              {isVariantAdded ? (
                <div id={"all-selected-attrs"}>
                  {selectedAttributes.map((attr, ind) => (
                    <VariantDropdown
                      disabled={isReadOnly}
                      key={`${attr.keyId}-${ind}`}
                      placeholder={
                        varaintKeys.length
                          ? `${varaintKeys
                            .slice(0, 3)
                            .join(", ")} etc`
                          : VariantGeneral.placeholder
                      }
                      label={
                        varaintKeys.length
                          ? `Select ${varaintKeys
                            .slice(0, 3)
                            .join(", ")} etc`
                          : VariantGeneral.label
                      }
                      options={
                        varaintKeys.length ? varaintKeys : undefined
                      }
                      varianData={
                        varaintKeys.length ? varianData : undefined
                      }
                      selectedAttributes={attr}
                      handleSaveAttributeOptions={(key, options) =>
                        handleSaveAttributeOptions(
                          key,
                          options,
                          attr.keyId,
                          ind
                        )
                      }
                      allAttributes={selectedAttributes}
                      isEditMode={isEditMode[ind]}
                      setIsEditMode={(val) => handleSetEdit(ind, val)}
                      draggable={true}
                      onDragStart={(e) => {
                        if (isReadOnly) return;
                        dragStartRef.current = ind;
                      }}
                      onDragOver={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                      onDragEnter={(e) => {
                        if (isReadOnly) return;
                        dragOverRef.current = ind;
                      }}
                      onDragEnd={handleDragAttr}
                      stock={stock}
                      isFromEditFlow={Boolean(
                        stock && stock?.variants?.length
                      )}
                    />
                  ))}
                  {selectedAttributes.length <
                    (varaintKeys.length || 3) ? (
                    <UBButton
                      id="stock_add_attribute_btn"
                      iconComponent={<AddPlusIcon />}
                      className="add_attr_btn"
                      title="Add another attribute"
                      onClick={() => {
                        if (isAttributeButtonDisabled) {
                          setAttrBtnClick(true);
                          setSelectedAttributes((x) => [
                            ...x,
                            { keyId: "", attrOptions: [] },
                          ]);
                        }
                      }}
                      disabled={
                        (stock && stock?.variants?.length) ||
                        !isAttributeButtonDisabled
                      }
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
              {createdVariants?.length && isVariantAdded ? (
                <>
                  <div className="lineSeperator"></div>
                  <ParagraphText className="fontSize16 fontWeight500 newFontColor">
                    {camelCase(I18n.stock_variants)}
                  </ParagraphText>

                  <div className="createFormGridTwo">
                    <div className="d-flex align-items-center gap-2 ms-3"></div>
                  </div>
                  <div className="mx-3 d-flex gap-1 p-2">
                    {variantTableHead?.map((colName, ind) => (
                      <ParagraphText
                        key={ind}
                        className="fontSize14"
                        style={{
                          flex: colName?.flex,
                          width: colName?.width,
                          textAlign: colName?.textAlign,
                        }}
                      >
                        {colName?.name}
                      </ParagraphText>
                    ))}
                  </div>
                  <div className="m-3 my-1">
                    <div
                      className="lineSeperator w-100"
                      id="variants-ui"
                    ></div>
                    {createdVariants?.map((variant, ind) => (
                      <CreatedVariant
                        readOnly={isReadOnly}
                        key={ind}
                        variantData={variant}
                        ind={ind}
                        onImgAdd={setShowImageModal.bind(this, {
                          show: true,
                          value: ind,
                        })}
                        handleCallUpdateVariant={
                          handleCallUpdateVariant
                        }
                        handleUpdateVariantField={
                          handleUpdateVariantField
                        }
                        handleDeleteVariant={handleDeleteVariant}
                        showError={
                          showVariantErr &&
                          !Boolean(validateVariants([variant]).length)
                        }
                        hideDeleteIcon={createdVariants.length === 1}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <></>
              )}
              <Box mb={4} />
              {!isVariantAdded ? (
                <>
                  <ParagraphText className="fontSize16 fontWeight500 newFontColor">
                    {camelCase(I18n.pricing)}
                  </ParagraphText>
                  <Box mb={2} />
                  <div className="createFormGridTwo alignflexEnd">
                    <div className="createFormInputLeft">
                      <UBInput
                        inputId="create_stock_price_input"
                        readOnly={isReadOnly}
                        required
                        onChange={(e, value) => {
                          handleNumerInput(value, () =>
                            onChangeText(I18n.wholesale_price, value)
                          );
                        }}
                        error={{
                          show: errors?.wholesale_price,
                          text: errors?.wholesale_price,
                        }}
                        maxLength={6}
                        value={stockDetails.wholesale_price}
                        label={"Price"}
                        baseId="wholesale_price"
                        placeholder={I18n.placeholder_item_price}
                      />
                    </div>
                    <div className="createFormInputRight">
                      <UBInput
                        inputId="create_stock_discount_input"
                        readOnly={isReadOnly}
                        onChange={(e, value) => {
                          handleNumerInput(value, () => {
                            onChangeText(
                              I18n.discount_optional,
                              value
                            );
                          });
                        }}
                        error={{
                          show: errors?.discount_optional,
                          text: errors?.discount_optional,
                        }}
                        maxLength={6}
                        baseClassname="w-100"
                        label={I18n.discount_optional}
                        value={stockDetails.discount}
                        baseId="discount_optional"
                        placeholder={I18n.placeholder_item_discount}
                      />
                    </div>
                  </div>

                  <ParagraphText className={"fontSize14 newFontColor"}>
                    Final Price:{" Rs. "}
                    {Number(stockDetails.wholesale_price) -
                      Number(stockDetails.discount) >
                      0.009 ? roundToTwoDp(
                        Number(stockDetails.wholesale_price) -
                        Number(stockDetails.discount)
                      ).toFixed(2) : 0}
                  </ParagraphText>

                  <Box mb={3} />
                  <ParagraphText className="fontSize16 fontWeight500 newFontColor">
                    {camelCase(I18n.inventory)}
                  </ParagraphText>
                  <Box mb={2} />
                  <div className="createFormGridTwo alignflexEnd">
                    <div className="createFormInputLeft">
                      <UBInput
                        inputId="create_stock_quantity_input"
                        readOnly={isReadOnly}
                        required
                        onChange={(e, value) => {
                          handleNumerInput(value, () =>
                            onChangeText(I18n.quantity, value)
                          );
                        }}
                        error={{
                          show: errors?.quantity,
                          text: errors?.quantity,
                        }}
                        maxLength={6}
                        label={I18n.quantity}
                        value={stockDetails.quantity}
                        baseId="quantity"
                        placeholder={I18n.placeholder_item_quantity}
                        onKeyDown={handleIntegerInput}
                      />
                    </div>
                    <div className="createFormInputRight">
                      <UBInput
                        inputId="create_stock_low_stock_input"
                        readOnly={isReadOnly}
                        onChange={(e, value) => {
                          handleNumerInput(value, () =>
                            onChangeText(
                              I18n.minimum_order_qty_optional,
                              value
                            )
                          );
                        }}
                        error={{
                          show: errors?.minimum_order_qty_optional,
                          text: errors?.minimum_order_qty_optional,
                        }}
                        maxLength={6}
                        baseClassname="w-100"
                        label={I18n.minimum_order_qty_optional}
                        value={stockDetails.min_order_qty}
                        baseId="minimum_order_qty_optional"
                        placeholder={I18n.placeholder_item_moq}
                        onKeyDown={handleIntegerInput}
                      />
                    </div>
                  </div>

                  <div className="createFormGridTwo">
                    <div className="createFormInputLeft">
                      <UBInput
                        inputId="create_stock_weight_input"
                        readOnly={isReadOnly}
                        required
                        onChange={(e, value) => {
                          handleNumerInput(value, () =>
                            onChangeText(I18n.weight_gm, value)
                          );
                        }}
                        error={{
                          show: errors?.weight,
                          text: errors?.weight,
                        }}
                        maxLength={6}
                        label={I18n.weight_gm}
                        value={stockDetails.weight}
                        baseId="weight"
                        placeholder={I18n.placeholder_item_weight}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <ParagraphText className="fontSize16 fontWeight500 newFontColor">
                {camelCase(I18n.addtional_information)}
              </ParagraphText>
              <Box mb={2} />
              <div className="createFormGridTwo">
                <div className="createFormInputLeft mbt-align">
                  <AppInputDropDown
                    data={{
                      value: stockDetails.warranty_period,
                      error: errors?.warranty_period,
                      title: I18n.warranty_period,
                      list: periods,
                      onChangeText,
                      id: "warranty_period",
                      required: true
                    }}
                    RenderInput={(params = {}) => (
                      <StockDropDownInput
                        placeholder={I18n.placeholder_item_warranty}
                        // label={I18n.warranty_period}
                        params={params}
                        disabled={isReadOnly}
                      />
                    )}
                  />
                </div>

                <div className="createFormInputRight">
                  <UBInput
                    inputId="create_stock_description_input"
                    readOnly={isReadOnly}
                    required
                    onChange={(key, value) => {
                      onChangeText(I18n.item_details, value);
                    }}
                    error={{
                      show: errors?.specification,
                      text: errors?.specification,
                    }}
                    baseClassname="w-100 inputMarginBottom"
                    value={stockDetails.specification}
                    label={I18n.item_details}
                    baseId="specification"
                    placeholder={I18n.placeholder_item_detail}
                  />
                </div>
              </div>
              <div className="marginBottom25">
                <ParagraphText className="mb-2 fontSize14">
                  {I18n.return_policy_and_warranty_details}
                </ParagraphText>

                <UBInput
                  inputId="create_stock_return_policy_input"
                  readOnly={isReadOnly}
                  onChange={(e, value) => {
                    onChangeText(
                      I18n.return_policy_and_warranty_details,
                      value
                    );
                    triggerLogEvent(analytics, "sc_stock_create_policy");
                  }}
                  value={stockDetails.terms_and_cond}
                  placeholder={I18n.placeholder_item_return_policy}
                />

              </div>
              {stock ? (
                <div className="outofStockToggleBox">
                  <ParagraphText className="fontSize14 newFontColor">
                    {I18n.out_of_stock}
                  </ParagraphText>
                  <AppSwitch
                    checked={stockDetails.out_of_stock}
                    title={I18n.out_of_stock}
                    onChange={onChangeText}
                    disabled={isReadOnly}
                  />
                </div>
              ) : null}

              {!isReadOnly && <Box className={styles.StockManagmentAction}>
                <UBButton
                  id="stock_save_btn"
                  title={
                    stock
                      ? stock.approval_status == "publish"
                        ? I18n.un_publish
                        : I18n.save
                      : I18n.save_for_later
                  }
                  loading={load.createLoad}
                  className={"ubPrimaryButton saveButton"}
                  onClick={() => handleCreatStock()}
                  disabled={disabled || load.createLoad}
                />
                <UBButton
                  id="stock_publish_btn"
                  title={stock ? I18n.publish : I18n.save_and_publich}
                  className={"ubPrimaryButton saveButton"}
                  onClick={() => handleCreatStock(true)}
                  iconComponent={<EnterIcon />}
                  iconPlacement="right"
                  disabled={disabled || load.createLoad}
                />
              </Box>}
            </Box>
          </Box>
        </Box>
      </Grid>
      <ImageModal
        header={{ title: "stock_image" }}
        body={{
          title: I18n.upload_or_create_stock,
          image: stockDetails.image_url,
          toggle: imageModal,
          toggleImageModal,
        }}
        footer={!isReadOnly ? [
          {
            data:
            {
              onClick: handleDeleteImage,
              title: I18n.delete,
              className: "ubSecondaryButton",
            }
          }, {
            data: {
              className: "ubPrimaryButton",
              title: I18n.upload_image,
              onClick: handleReupload,
              id: `image_upload_btn`,
            }
          },

        ] : [
          {
            data:
            {
              onClick: () => toggleImageModal(),
              title: I18n.close,
              className: "ubPrimaryButton",
            }
          }
        ]}
      />
      <ConfirmationModal
        open={publishModal}
        onClose={() => togglePublishModal(false)}
        onConfirm={() => handleCreatStock(true)}
        message={I18n.publish_item}
        confirmText={I18n.yes}
        cancelText={I18n.no}
        id="publish_stock_item_modal"
        loading={load.publishLoad}
        title={`${I18n.would_you_like_to_publish_this} "${stockDetails.name}" ${I18n.on_your_catalog}`}
        confirmButtonClassName="ubPrimaryButton"
      />
      
      <ImageAddModal
        show={showImageModal.show}
        handleClose={handleImgModClose}
        onSave={handleImgModSave}
        saveIndex={showImageModal.value}
        ImgArr={imageList}
        onCancel={handleImgModCancel}
        setImageArr={setImageList}
        currentImage={createdVariants[showImageModal.value]}
      />
      <ConfirmationModal
        open={deleteModal}
        onClose={() => toggleDeleteModal(false)}
        onConfirm={handleDeleteStock}
        message={`${I18n.would_you_like_to_delete} ${I18n.this_item} "${stockDetails?.name}" ?`}
        confirmText={I18n.yes}
        cancelText={I18n.no}
        id="delete_stock_item_modal"
        loading={deleteLoad}
        title={""}
        confirmButtonClassName="ubPrimaryButton"
      />
    </Grid>
  );
};

export default CreateStock;
